import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import About from "./pages/About";
import Ticket from "./pages/Ticket";
import Notary from "./pages/Notary";
import Pardon from "./pages/Pardon";
import Drafting from "./pages/Drafting";
import Services from "./pages/Services";
import ContactUs from "./pages/ContactUs";
import SmallClaimCourt from "./pages/SmallClaimCourt";
import LandlordTenantDispute from "./pages/LandlordTenantDispute";
import FamilyLegalServices from "./pages/FamilyLegalServices";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ErrorPage from "./pages/ErrorPage";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './i18n';

function App() {
  return (
    <div className="App">
      <>
        <BrowserRouter>
          <Helmet>
            <title>
              Cabinet de Avocatură și Insolvență în București | Min & Ying Legal Services Professional Corporation Professional Corporation
            </title>
            <meta
              name="description"
              content="Cabinet de avocatură și insolvență condus de Min & Ying Legal Services Professional Corporation Professional Corporation. Consultanță, asistență și reprezentare pentru probleme juridice și de insolvență. Contactați-ne pentru soluții profesioniste."
            />
          </Helmet>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/ticket" element={<Ticket />} />
            <Route path="/services/notary" element={<Notary />} />
            <Route path="/services/drafting" element={<Drafting />} />
            <Route path="/services/pardon" element={<Pardon />} />
            <Route path="/services/family-legal-services" element={<FamilyLegalServices />} />
            <Route path="/services/small-claim-court" element={<SmallClaimCourt />} />
            <Route path="/services/landlord-tenant-dispute" element={<LandlordTenantDispute />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/about" element={<About />} />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </>
    </div>
  );
}

export default App;
